import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Moon, Sun, Menu, X } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';
import { useTheme } from '../contexts/ThemeContext';
import { NAV_ITEMS } from '../data/divisions';
import { Logo } from './Logo';
import './Header.css';

export function Header() {
  const { language, changeLanguage, t } = useI18n();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo-container">
          <Link to="/" className="logo-link" aria-label="Skycodee">
            <Logo />
            <span className="app-title">
              Sky<span className="app-title-accent">codee</span>
            </span>
          </Link>
        </div>

        <div className="header-actions">
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>

          <nav className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.key}
                  to={item.path}
                  className={({ isActive }) => `nav-link ${item.accent} ${isActive ? 'active' : ''}`}
                >
                  <Icon size={17} />
                  <span>{t(item.navKey)}</span>
                </NavLink>
              );
            })}
          </nav>

          <button
            className="icon-btn"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title="Toggle theme"
          >
            {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
          </button>

          <button
            className="icon-btn"
            onClick={() => changeLanguage(language === 'en' ? 'pl' : 'en')}
            aria-label="Toggle language"
            title={language === 'en' ? 'Polski' : 'English'}
          >
            <img
              src={language === 'en' ? '/flags/us.svg' : '/flags/pl.svg'}
              alt={language === 'en' ? 'English' : 'Polski'}
              className="flag-icon"
            />
          </button>
        </div>
      </div>
    </header>
  );
}
